export enum VoucherType {
  'eVoucher (Retail Store only)' = 1,
  'eVoucher (eShop only)' = 2,
  'FPS' = 3,
  'Bank transfer' = 4,
  'Cash' = 5,
  'VOUCHER_TYPE_ELECTRONIC' = 2,
}
